import styled from '@emotion/styled';
import { Link } from 'src/components-dummy';

export const LinkStyled = styled(Link)``;
